import List from './actions/list';
import Find from './actions/find';
import Resource from './resource';

export default class Group extends Resource {
  get resourceName() {
    return 'group';
  }

  get resourcesName() {
    return 'groups';
  }
}
// @ts-ignore
List.includeInto(Group);
// @ts-ignore
Find.includeInto(Group);
